<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="productTechnologies"
    :search="search"
    @dblclick:row="handleClickRow"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>TECNOLOGIAS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark to="/tecnologia/novo">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.updated_at="{ item }">
      {{ item.updated_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.icon="{ item }">
      <v-img
        :lazy-src="getUrlPhoto(item.icon)"
        max-height="50"
        max-width="50"
        :src="getUrlPhoto(item.icon)"
      ></v-img>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="error">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red darken-1"
            @click="deleteItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Deletar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { URL_IMAGE } from "@/api/config";

import * as API from "@/api/requests/ProductTechnologyRequest";

export default {
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
        width: 50,
      },
      { text: "Nome", value: "name", width: 250 },
      { text: "Descrição", value: "description", width: 250 },
      { text: "Icone", value: "icon", width: 150 },
      { text: "Status", value: "status", width: 75 },
      { text: "Data Cadastro", value: "created_at", width: 150 },
      { text: "Última Atualização", value: "updated_at", width: 150 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    productTechnologies: [],
    editedItem: {
      name: "",
      photo: "",
      status: 1,
    },
    defaultItem: {
      name: "",
      photo: "",
      status: 1,
    },
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getProcutTechnologies();
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getProcutTechnologies() {
      this.loading = true;
      this.productTechnologies = [];
      try {
        this.productTechnologies = await API.getAll();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({
        name: "ProductTechnologyEdit",
        params: { id: item.id },
      });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.productTechnologies = [];
      try {
        await API.destroy(this.editedItem.id);
        this.loading = false;
        this.initialize();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    getUrlPhoto(icon) {
      if (icon !== "") {
        return `${URL_IMAGE}${icon}`;
      } else {
        return "";
      }
    },
    handleClickRow(event, item) {
      this.editItem(item.item);
    },
  },
};
</script>
